var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"table":_vm.table,"default_limit":'1000',"default_sort":'name',"extension":'',"formview":_vm.formview,"export_csv":false,"addbutton":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }